import { eraseCookie, setCookie, getCookie } from '../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { get_request_params } from '../../properties/headers';
import {SomethingWentWrong, controller} from "../helpers";
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { LOGOUTMESSAGE } from "../../constant"
import { isVersionBuildUpdated } from '..';

const trimObj = (obj) => {
	const keys = Object.keys(obj);
	keys.forEach(item => {
		if (typeof obj[item] === "string") {
			obj[item] = obj[item].trim();
		}
	});
}

const putpost = async (url, _success, _failure, obj, type, header, id='',customFailureToast) => {
  try {
    const validObj = trimObj(obj);
    const request_params = get_request_params(type, JSON.stringify(obj), header,id);
    const lastLocation = document.URL.split('#')[1];
    if(lastLocation !== '/auth'){
      setCookie('lastKnowPath', lastLocation);
    }
    fetch(url, request_params)
      .then(function (response) {
        isVersionBuildUpdated(response)
        if ((response.status === 403 || response.status === 401) && getCookie('token')) {
          failureToast(LOGOUTMESSAGE);
          eraseCookie('token');
          controller.abort();
          setTimeout(()=>window.location.replace(`${document.URL.split('#')[0]}`), 3000);
          return null
        }
        if(response.status === 412 ){
            return response.json()
        }
        if (response.ok) {
          return response.json();
        } 
        if(customFailureToast){
          return response.json()
        }
        else {
          response
            .json()
            .then(er => {
              _failure(er);
            })
            .catch(error => { });
        }
      })
      .then(function (data) {
        if (data && data['code'] == '400') {
          if(customFailureToast)
            _success(data)
          else
          _failure(data);
        } else {
          _success(data);
        }
      })
      .catch(error => {
        console.log(error);
        // _failure(error)
      });
  } catch (e) {
      SomethingWentWrong();
    //console.log('Error', e);
  }
};

export const postApi = async (url, _success, _failure, obj, type, header, id='') => {
  try {
    const validObj = trimObj(obj);
    const request_params = get_request_params(type, JSON.stringify(obj), header, id);
    const lastLocation = document.URL.split('#')[1];
    if (lastLocation !== '/auth') {
      setCookie('lastKnowPath', lastLocation);
    }

    const response = await fetch(url, request_params);
    isVersionBuildUpdated(response);

    if ((response.status === 403 || response.status === 401) && getCookie('token')) {
      failureToast(LOGOUTMESSAGE);
      eraseCookie('token');
      controller.abort();
      setTimeout(() => window.location.replace(`${document.URL.split('#')[0]}`), 3000);
      return null;
    }

    if (response.status === 504) {
      console.log("504 Gateway Timeout encountered");
      // Handle the timeout (retry, notify user, etc.)
      _failure({ message: "Gateway Timeout. Please try again later." });
      return null;
    }

    if (response.status === 412) {
      const data = await response.json();
      const state = response.headers.get('State');
      _success({...data,state});
      return;
    }

    if (response.ok) {
      const data = await response.json();
      const state = response.headers.get('State'); // Extract the desired header state
  // Pass data and state to _success
      if (data && data['code'] === '400') {
        _failure(data);
      } else {
        _success({...data,state});
      }
    } else {
      const errorData = await response.json();
      _failure(errorData);
    }
  } catch (error) {
    console.log("An error occurred:", error);
   // SomethingWentWrong();
    _failure(error);
  }
};


export { putpost };
